import React, { Fragment } from "react";
import { TickRenderer } from "../../../../libraries/ReportGenerator/TickRenderer";
import { getTotalMiles } from "../../utils/getTotalMiles";

const LocationOptions = {
  West: "West",
  East: "East",
  Both: "Both",
  Centre: "Centre",
};

export const ONR_BallastRequirementsFormSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
        header2: "auto",
      },
      minDataRowsCount: 10,
      columns: [
        {
          title: "Mileage",
          colSpan: 4,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "From",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "from",
            },
            {
              title: "To",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "to",
            },
          ],
        },
        {
          title: "Total Miles",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: ["from", "to"],
          dontJoinValues: true,
          formatter: getTotalMiles,
        },
        {
          title: "Location Description",
          colSpan: 8,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "West",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.West),
            },
            {
              title: "East",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.East),
            },
            {
              title: "Both",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.Both),
            },
            {
              title: "Centre",
              colSpan: 2,
              rowSpan: 1,
              className: "tbl-text-normal",
              accessor: "loc",
              formatter: (val) => TickRenderer(val, LocationOptions.Centre),
            },
          ],
        },
        {
          title: ["Remarks", "(e.g., type of rock-ballast, reject, shot rock, ", "rip rap, granular A, etc.)"],
          titleFormatter: (titles) => (
            <div>
              <div>{titles[0]}</div>
              <div style={{ fontWeight: 100 }}>{titles[1]}</div>
              <div style={{ fontWeight: 100 }}>{titles[2]}</div>
            </div>
          ),
          colSpan: 8,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "com",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/BallastRequirementsForm/ONR_BallastRequirementsFormSchema.js